import React from 'react'
import { Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { loadDriver, clearDriver, deleteDriver } from '../../common/drivers/actions'
import { Title } from '../components'
import {DriversImportForm} from '../forms'
import { roles } from '../../common/config'

class DriversImportPage extends React.Component {
  componentDidMount() {

  }
  componentWillUnmount() {

  }

  render() {
    const { match, viewer, drivers } = this.props
    const { params } = match

    const title = 'Import řidičů'
    return (
      <div>
        <Title message={title} />
        <aside className="breadcrumbs">
          <Link to="/drivers">Řidiči</Link>
          <img src="/images/arrow.png" alt="arrow-right" />
          <span>{title}</span>
          <div className="options">

          </div>
        </aside>
        <main className="form-page thick">
          <DriversImportForm role={viewer.role} attendSource={params.attendSource} />
        </main>
      </div>
    )
  }
}

DriversImportPage.propTypes = {
  match: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object.isRequired,
}

export default connect(state => ({
  viewer: state.users.viewer
}), { })(DriversImportPage)



// WEBPACK FOOTER //
// ./src/browser/pages/DriversImport.js